import { Component, Input } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { doGetInvalidControlsList, doTouchAllFields } from '../../workflow-utils';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { InvalidFormDrawerComponent } from '../invalid-form-drawer/invalid-form-drawer.component';

@Component({
	selector: 'app-invalid-form-indicator',
	standalone: false,
	templateUrl: './invalid-form-indicator.component.html',
	styleUrl: './invalid-form-indicator.component.scss'
})
export class InvalidFormIndicatorComponent {
	@Input() form!: FormGroup;
	@Input() field?: string;
	@Input() fields?: string[];

	constructor(private drawerService: NzDrawerService) { }

	touchAllFields() {
		doTouchAllFields(this.form);
	}
	getInvalidControlsList() {
		return doGetInvalidControlsList(this.form);
	}
	openDrawer() {
		const ref = this.drawerService.create({
			nzTitle: 'Errors',
			nzContent: InvalidFormDrawerComponent,
			nzWidth: 'large',
			nzContentParams: { form: this.form, field: this.field, fields: this.fields }
		});
		ref.open();
	}
	get valid(): boolean {
		try {
			if (!this.field && !this.fields) {
				return this.form.valid;
			}
			if (this.field && !this.fields) {
				return this.form.get(this.field)!.valid;
			}
			if (!this.field && this.fields) {
				for (let field of this.fields) {
					if (!this.form.get(field)!.valid) {
						return false;
					}
				}
				return true;
			}
			for (let field of this.fields!) {
				if (!this.form.get(field)!.valid) {
					return false;
				}
			}
			return this.form.get(this.field!)!.valid;
		} catch (e) {
			console.log(`Error checking if field is valid or not: [${this.field}].  ` + e);
			return true;
		}
	}
}
